import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take } from 'rxjs';
import { UserEnsureService } from './services/user-ensure.service';

interface AppStateWithTarget {
  target?: string;
}
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private auth = inject<AuthService<AppStateWithTarget>>(AuthService);
  private router = inject(Router);
  private userEnsure = inject(UserEnsureService);

  ngOnInit(): void {
    // Kick off ensure-user sync as soon as auth state is available.
    this.userEnsure.start();

    const hasAuthRedirectParams =
      window.location.search.includes('code=') && window.location.search.includes('state=');

    // Ensure appState-based return navigation works reliably after login.
    if (hasAuthRedirectParams) {
      this.auth
        .handleRedirectCallback()
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            const target = result?.appState?.target;
            if (typeof target === 'string' && target.startsWith('/')) {
              this.router.navigateByUrl(target, { replaceUrl: true });
            }
          },
          error: (e) => console.error(e),
        });
      return;
    }

    this.auth.appState$
      .pipe(
        filter((s): s is AppStateWithTarget => !!s && typeof (s as any).target === 'string'),
        take(1),
      )
      .subscribe((s) => {
        const target = s.target!;
        if (target.startsWith('/')) {
          this.router.navigateByUrl(target, { replaceUrl: true });
        }
      });
  }
}
